jQuery(function ($) {
  if ($(".product-main .about-description .product-desc").text().length > 550) {
    $(
      '<a class="show-more" style="cursor: pointer;">See more...</a>'
    ).insertAfter(".product-main .about-description .product-desc");
    $(".product-main .about-description .show-more").click(function () {
      if (
        $(".product-main .about-description .product-desc").hasClass(
          "show-more-height"
        )
      ) {
        $(this).text("See less...");
      } else {
        $(this).text("See more...");
      }

      $(".product-main .about-description .product-desc").toggleClass(
        "show-more-height"
      );
    });
  }

  document
    .querySelectorAll(
      ".pdp-customer_review .jdgm-rev-widg__body .jdgm-rev-widg__reviews .jdgm-rev"
    )
    .forEach(function (jdgmItem) {
      let authorLogo = jdgmItem.querySelector(".jdgm-rev__icon").textContent;
      let authorname = jdgmItem.querySelector(".jdgm-rev__author").textContent;
      let customBottom = `
      <div class="custom-bottom">
        <div class="auther-logo">${authorLogo}</div>
        <div class="name-and-verify-purchase">
            <div class="author-name"> ${authorname} </div>
            <div class="verify-purchase">
                <img src="https://cdn.shopify.com/s/files/1/0550/8248/3769/files/Check_1.png?v=1686651900" alt="" width="6px" height="4px" />
                VERIFIED PURCHASE
            </div>
        </div>
      </div>
    `;
      jdgmItem
        .querySelector(".jdgm-rev__body")
        .insertAdjacentHTML("afterend", customBottom);
    });
  $(".pdp-customer_review .jdgm-rev-widg__body .jdgm-rev-widg__reviews").slick({
    infinite: true,
    arrow: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          autoplay: true,
          autoplaySpeed: 5000,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
